import sideMenuActionTypes from "./side-menu.types";

export const toggleSideNav = () => ({
  type: sideMenuActionTypes.TOGGLE_SIDENAV,
});

export const setSideMenu = (data) => ({
  type: sideMenuActionTypes.SET_SIDE_NAVIGATION_MENU,
  payload: data,
});
